import { createFileRoute } from '@tanstack/react-router';
import Entities from 'containers/Entities';

export const Route = createFileRoute('/_authenticated/entities')({
  component: Entities,
});
